<template>
  <div class="mt-200">
    <div class="is-size-6 has-text-weight-bold ml-50 mb-100">Add the following users to the record</div>
    <div class="columns users">
      <div class="column mr-50 p-0" v-for="user in addUsers" :key="user.id" style="flex: none; width: 30px;">
        <app-avatar :user-id="user.id"></app-avatar>
      </div>
      <status-automation-set-users
        :selected-users="addUsers"
        class="column p-0"
        style="max-width: 30px"
        @setUsers="val => { $emit('setUsers', { prop: 'usersToAddToRecord', val }) }"
        :smallLabel="addUsers.length ? '' : 'Set Users'"
      ></status-automation-set-users>
    </div>

    <div class="is-size-6 has-text-weight-bold ml-50 mb-100">Remove the following users from the record</div>
    <div class="columns users">
      <div class="column mr-50 p-0" v-for="user in removeUsers" :key="user.id" style="flex: none; width: 30px;">
        <b-tooltip :label="user.full_name" position="is-bottom">
          <app-avatar :user-id="user.id"></app-avatar>
        </b-tooltip>
      </div>
      <status-automation-set-users
          :selected-users="removeUsers"
          class="column p-0"
          style="max-width: 30px"
          @setUsers="val => { $emit('setUsers', { prop: 'usersToRemoveFromRecord', val }) }"
          :smallLabel="removeUsers.length ? '' : 'Set Users'"
      ></status-automation-set-users>
    </div>
  </div>
</template>

<script>
import StatusAutomationSetUsers from './StatusAutomationSetUsers';

export default {
  name: 'StatusManageUsersAutomation',
  components: {
    StatusAutomationSetUsers
  },
  props: {
    addUsers: Array,
    removeUsers: Array
  },
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.users {
  padding: 10px;
  width: 100%;
  margin-right: 0;
  margin-left: 0;

  p {
    font-size: 11px;
    font-weight: bold;
  }
}
</style>
